import React from 'react'
import { parentUrl } from '../../App/App.config'
import pushGTMEvent from '../../util/helper/pushGTMEvent'

const configContents = ({
  auth: { isAuthenticated, loginWithRedirect },
  state: { userSession, langStrings, gtmAnalyticsPushed },
  dispatch,
}) => {
  const handleSignIn = () => {
    console.log('[CM] Logging in with returnTo:', parentUrl)
    loginWithRedirect({
      appState: {
        returnTo: parentUrl,
      },
      redirectMethod: 'replace', // needed to avoid window.parent.history write error
      redirectTarget: window.parent.location,
    })
  }

  let contents
  if (isAuthenticated) {
    if (gtmAnalyticsPushed !== 'ContactInfo') {
      pushGTMEvent('ContactInfo')
      dispatch({
        type: 'ANALYTICS_SENT',
        payload: { gtmAnalyticsPushed: 'ContactInfo' },
      })
    }
    contents = [
      {
        isTitle: true,
        hasNarrowBottom: true,
        description: langStrings
          ? langStrings.signIn.helloUser.replace(
              '<first-name>',
              userSession.first,
            )
          : 'Hello <first-name>!',
        id: 'adsk-page-title',
      },
      {
        isTitle: true,
        hasLargeBottom: true,
        description: langStrings
          ? langStrings.cm.welcome.clickGetStarted
          : 'Click Get Started to change your contract manager.',
      },
    ]
  } else {
    if (gtmAnalyticsPushed !== 'Welcome') {
      pushGTMEvent('Welcome')
      dispatch({
        type: 'ANALYTICS_SENT',
        payload: { gtmAnalyticsPushed: 'Welcome' },
      })
    }
    contents = [
      {
        isTitle: true,
        description: langStrings
          ? langStrings.signIn.startAccessAccount
          : 'Let’s start with accessing your account.',
      },
      {
        isShown: true,
        isCustomComponent: true,
        customComponent: (
          <div style={{ marginBottom: '10px' }}>
            <a
              id="adsktm-cm-account-login"
              style={{
                color: '#3c3c3c',
                fontSize: '21px',
                fontWeight: '600',
                fontFamily: 'ArtifaktElement,sans-serif',
                textDecoration: 'none',
                borderBottom: '1px dashed #999',
                cursor: 'pointer',
              }}
              onClick={handleSignIn}
            >
              {langStrings.signIn.signInNow
                .replace(/<a>/g, '')
                .replace(/<\/a>/g, '')}
            </a>
          </div>
        ),
      },
      {
        description: langStrings
          ? langStrings.signIn.signInHelp
          : '<a target="_blank" href="https://knowledge.autodesk.com/contact-support/account-management/account-creation-sign-profile-management">Having trouble signing in?</a>',
        style: { color: '#777', fontWeight: 600 },
        paragraphStyle: { marginBottom: '40px' },
      },
    ]
  }

  contents.push(
    {
      description: langStrings ? langStrings.welcome.noteForTheUser : 'Note:',
      style: { fontSize: '19px' },
      paragraphStyle: { marginBottom: '20px', lineHeight: '24px' },
    },
    {
      hasBullet: true,
      description: langStrings
        ? langStrings.cm.welcome.noteBullet1
        : 'You can change the contract manager for maintenance plans and subscriptions that are not auto-renewing.',
    },
    {
      hasBullet: true,
      description: langStrings
        ? langStrings.cm.welcome.noteBullet2
        : 'If you have an auto-renewing subscription, you will have to cancel the subscription and start a new one to change the contract manager.',
    },
  )
  return contents
}

const configFooter = ({
  auth: { isAuthenticated, loginWithRedirect },
  state: { langStrings },
  dispatch,
}) => {
  const getStarted = langStrings
    ? langStrings.buttons.getStartedButton
    : 'GET STARTED'
  const signIn = langStrings ? langStrings.buttons.signInButton : 'SIGN IN'

  const handleSignIn = () => {
    loginWithRedirect({
      appState: {
        returnTo: parentUrl,
      },
      redirectMethod: 'replace', // needed to avoid window.parent.history write error
      redirectTarget: window.parent.location,
    })
  }

  const res = {
    hideBackButton: true,
    nextButtonContent: isAuthenticated ? getStarted : signIn,
    handleNext: () => {
      if (isAuthenticated) dispatch({ type: 'GO_TO_REVIEW_ACCOUNT_PAGE' })
      else handleSignIn()
    },
    handleNextButtonId: 'adsktm-cm-next-button',
  }
  return res
}

export default {
  configContents,
  configFooter,
}
